import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export interface TabStates {
	w1: boolean;
	w2: boolean;
	w3: boolean;
	w4: boolean;
	z1: boolean;
	z2: boolean;
	z3: boolean;
	z4: boolean;
	z5: boolean;
	z6: boolean;
	b1: boolean;
	b2: boolean;
	b3: boolean;
	b4: boolean;
	bde1: boolean;
	bde2: boolean;
	bde3: boolean;
	bde4: boolean;
	bde5: boolean;
	pze1: boolean;
	t1: boolean;
	t2: boolean;
	t3: boolean;
	t4: boolean;
	t5: boolean;
	t6: boolean;
	dayView: boolean;
	us1: boolean;
	pr1: boolean;
	f1: boolean;
	f2: boolean;
	f3: boolean;
	p1: boolean;
	p2: boolean;
	qa1: boolean;
}

@Injectable()
export class TabStateService {
	// Initialize with the initial tab state from localStorage to avoid null state
	private tabStates$ = new BehaviorSubject<any>(this.getInitialTabState());
	public TabStates$ = this.tabStates$.asObservable().pipe(
		map((tabStates) => {
			// Safety check to ensure tabStates is not null
			if (!tabStates) {
				return {} as TabStates;
			}
			return Object.keys(tabStates).reduce((acc, key) => {
				acc[key] = tabStates[key] === 1;
				return acc;
			}, {} as TabStates);
		})
	);

	constructor() {
		// No need to call next() here, already initialized with data
	}

	// Helper method to get initial state from localStorage
	private getInitialTabState(): any {
		let existingTabEntries = JSON.parse(localStorage.getItem('tabActives'));
		if (existingTabEntries == null) {
			existingTabEntries = {};
		}
		return existingTabEntries;
	}

	public onTabOpen(name: string) {
		let existingTabEntries = JSON.parse(localStorage.getItem('tabActives'));
		if (existingTabEntries == null) {
			existingTabEntries = {};
		}

		existingTabEntries[name] = 1;
		localStorage.setItem('tabActives', JSON.stringify(existingTabEntries));

		this.tabStates$.next(existingTabEntries);
	}

	public onTabClose(name: string) {
		let existingTabEntries = JSON.parse(localStorage.getItem('tabActives'));
		if (existingTabEntries == null) {
			existingTabEntries = {};
		}

		existingTabEntries[name] = 0;
		localStorage.setItem('tabActives', JSON.stringify(existingTabEntries));

		this.tabStates$.next(existingTabEntries);
	}

	public getTabState(name: string = null) {
		let existingTabEntries = JSON.parse(localStorage.getItem('tabActives'));
		if (existingTabEntries == null) {
			existingTabEntries = {};
		}
		if (name) {
			return existingTabEntries[name] ?? true;
		}
		return existingTabEntries;
	}
}
